module.exports = __webpack_public_path__ + "./kit/docs/img/kit-channel-ip.0282f91567c93638aa42302e60f2fa26.svg";